import React from "react"
import { getRootBlock } from "../../utils/helpers"

/**
 * This component creates the list of items in the block menu by relying on the
 * block that opened it. In other words, it's not paired with the hover state,
 * but rather with the element that opens it. This was originally made to work
 * alongside the slash menu.
 *
 * @param {function} options
 * @param {boolean} hasFocus
 * @param {function} onSelect
 * @param {object} anchor { node, editor, index }
 */
export default function AnchoredBlockMenuList({
  options = () => [],
  onSelect = () => {},
  anchor
}) {
  const rootBlock = getRootBlock(anchor.editor.value, anchor.node)

  const handleSelect = (editor, rootBlock, option) => {
    const removeShortcode = () => {
      // TODO: If you use a shortcode in an empty text block, this line will
      // remove the node, which crashes `insertBlock`. We might need to make
      // this line conditional depending on whether or not there's other content
      // in the text block.
      anchor.editor.removeNodeByKey(anchor.node.key)
    }

    const isInsertingBlock = option.type.endsWith("_block")

    try {
      if (isInsertingBlock) removeShortcode()

      onSelect(editor, rootBlock, option)
      option.onSelect(editor, rootBlock)

      if (!isInsertingBlock) removeShortcode()
    } catch (err) {
      console.error(`"${option.type}" couldn't be inserted.`, err)
    }
  }

  return (
    <div
      id="block-menu-list"
      className="bg-white absolute rounded shadow p-2 overflow-y-scroll border border-gray-200 pointer-events-auto flex flex-col w-full z-10"
      style={{ maxHeight: 350 }}
    >
      {options(rootBlock).map((option, index) => (
        <button
          key={index}
          onClick={() => handleSelect(anchor.editor, rootBlock, option)}
          className={`my-1 p-1 rounded duration-200 transition-colors focus:outline-blue hover:bg-gray-100 ${
            anchor.index === index ? "bg-gray-100" : ""
          }`}
          data-active-block-toolbar-item={anchor.index === index ? true : null}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
